import { DictionaryItem } from '../../types';

import cn from '../../styles.module.css';

const formatItems = (list: DictionaryItem[]): DictionaryItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, any> = {
      riskScore: (
        <div>
          {result?.riskScore !== null &&
          result?.riskScore !== undefined &&
          result?.riskScore?.toString() ? (
            result?.riskScore
          ) : (
            <div className={cn.emptyRow} />
          )}
        </div>
      ),
      code: (
        <div className={result?.code ? cn.dictionaryItemCodeRow : ''}>
          {result?.code ? (
            <div className={cn.dictionaryItemCode}>{result?.code}</div>
          ) : (
            <div className={cn.emptyRow} />
          )}
        </div>
      ),
      description: (
        <div>
          {result?.description ? (
            <div className={cn.dictionaryItemDescription}>
              {result?.description}
            </div>
          ) : (
            <div className={cn.emptyRow} />
          )}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatItems;
